import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 会话管理端（controller/admin + 挂件共用消息端点）
 */

/** 会话列表分页（status/agentId/keyword/closeCategory/pageNum/pageSize） */
export function listAdminSessions(params) {
  return axios.get(`${base.url}/service/v1/admin/sessions`, { params })
}

/** 会话历史导出（blob） */
export function exportSessions(params) {
  return axios.get(`${base.url}/service/v1/admin/sessions/export`, {
    params,
    responseType: 'blob'
  })
}

/** 修改会话结束分类 */
export function updateCloseCategory(sessionId, closeCategory) {
  return axios.put(`${base.url}/service/v1/admin/sessions/${sessionId}/close-category`,
    JSON.stringify({ closeCategory }),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 会话消息历史（与客服工作台共用） */
export function getSessionMessages(sessionId) {
  return axios.get(`${base.url}/service/v1/chat/sessions/${sessionId}/messages`)
}